import React, { useEffect } from 'react';
import { PackageForm } from '../../../Components/Form';
import { FormLayout } from '../../../Components';
import { NewPackageIcon } from '../../../Assets/Navigation/NavigationIcons';
import { useTranslation } from 'react-i18next';

const AddPackage = ({ handleToast }) => {
  const { t } = useTranslation();
  useEffect(() => {
    document.title = t('Packages.add_package');
  }, []);

  return (
    <FormLayout
      title={t('Packages.create_new_package')}
      Icon={NewPackageIcon}
      closeUrl="/packages"
      iconstyle="general_module_icon"
      layoutBoxClass="uiux-form-redesign"
    >
      <PackageForm
        // title="Add New Package"
        type="add"
        handleToast={handleToast}
      />
    </FormLayout>
  );
};

export default AddPackage;
